import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';

const TrainingIntelligenceBanks = () => {
  const trainingUses = [
    'Customer and member communication standards',
    'Account onboarding conversations',
    'Product and service education',
    'Cross-sell and referral fundamentals',
    'De-escalation and conflict handling',
    'Professional phone etiquette',
    'Accuracy and clarity in financial conversations',
    'Call center and branch service alignment'
  ];

  const impacts = [
    'Faster onboarding',
    'Higher employee confidence',
    'Reduced errors',
    'Consistent service across locations'
  ];

  return (
    <section className="py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="p-8 md:p-12 rounded-3xl bg-gradient-to-br from-gray-900/90 to-blue-900/30 border border-cyan-500/30">
          <div className="flex items-start gap-6 mb-8">
            <div className="w-20 h-20 rounded-2xl overflow-hidden shadow-lg flex-shrink-0 border border-cyan-500/30">
              <img 
                src="https://customer-assets.emergentagent.com/job_f6991d0e-ab71-4b45-956d-bb71024e7667/artifacts/43k1hzko_Engine%20Icon.png" 
                alt="Traain Engine"
                className="w-full h-full object-cover"
              />
            </div>
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-2">
                Traain Engine
              </h2>
              <p className="text-xl text-cyan-400 font-semibold">
                Train Banking Teams Faster—With Confidence
              </p>
            </div>
          </div>

          <p className="text-lg text-gray-300 mb-8 leading-relaxed">
            Traain Engine™ delivers role-aware, compliance-aligned training that scales across branches, call centers, and support teams.
          </p>

          <div className="mb-8">
            <h3 className="text-xl font-bold text-white mb-4">Banks and credit unions use Traain Engine™ for:</h3>
            <div className="grid md:grid-cols-2 gap-4">
              {trainingUses.map((use, index) => (
                <div key={index} className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-cyan-400 rounded-full mt-2 flex-shrink-0" />
                  <span className="text-gray-300">{use}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="mb-8">
            <h3 className="text-xl font-bold text-white mb-4">Impact:</h3>
            <div className="grid md:grid-cols-2 gap-4">
              {impacts.map((impact, index) => (
                <div key={index} className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-green-400 rounded-full mt-2 flex-shrink-0" />
                  <span className="text-gray-300">{impact}</span>
                </div>
              ))}
            </div>
          </div>

          <Button
            variant="outline"
            className="border-2 border-cyan-500 text-cyan-400 hover:bg-cyan-500/10 hover:border-cyan-400"
          >
            Learn More → Traain Engine
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default TrainingIntelligenceBanks;